import * as constants from '../constants/constants';
import { axiosCaller } from "../utils/apiCaller";
import {ACTION, setButtonLoading, setLoading, wrap} from './generalActions'
import {toast} from "react-toastify";
import {translatedText} from "../components/TranslatedText"

// =====================
// NEW ACTIONS (servicing-v2)
// =====================

export const fetchServicingStats = () => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', 'servicing-v2/dashboard-stats').then(res => {
            dispatch({ "type": constants.FETCH_SERVICING_DASHBOARD_STATS, "payload": res.data.data });
            return res.data.data;
        })
    } catch(err) {}
}, 'FETCH_SERVICING_STATS')

export const fetchServicings = (filters: any = {}) => wrap(async(dispatch:any) => {
    try {
        dispatch(setLoading(true));
        const params: string[] = [];
        if (filters.status) params.push('status=' + filters.status);
        if (filters.priority) params.push('priority=' + filters.priority);
        if (filters.type) params.push('type=' + filters.type);
        if (filters.city) params.push('city=' + encodeURIComponent(filters.city));
        if (filters.search) params.push('search=' + encodeURIComponent(filters.search));
        if (filters.start_date) params.push('start_date=' + filters.start_date);
        if (filters.end_date) params.push('end_date=' + filters.end_date);
        if (filters.page) params.push('page=' + filters.page);
        if (filters.per_page !== undefined) params.push('per_page=' + filters.per_page);

        return await axiosCaller('GET', 'servicing-v2?' + params.join('&')).then(res => {
            dispatch(setLoading(false));
            dispatch({ "type": constants.FETCH_SERVICINGS, "payload": res.data });
            return res.data;
        })
    } catch(err) { dispatch(setLoading(false)); }
}, 'FETCH_SERVICINGS')

export const fetchServicing = (servicingId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', 'servicing-v2/' + servicingId).then(res => {
            dispatch({ "type": constants.FETCH_SERVICING_NEW, "payload": res.data.data });
            return res.data.data;
        })
    } catch(err) {}
}, 'FETCH_SERVICING')

export const createNewServicing = (payload: any) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('POST', 'servicing-v2', payload).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'CREATE_SERVICING')

export const transitionServicing = (servicingId: number, payload: any) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('PATCH', 'servicing-v2/' + servicingId + '/transition', payload).then(res => {
            if (res.data.error) return res.data;
            dispatch({ "type": constants.FETCH_SERVICING_NEW, "payload": res.data.data });
            return res.data;
        })
    } catch(err) { return err?.response?.data; }
}, 'TRANSITION_SERVICING')

export const uploadServicingFiles = (servicingId: number, formData: any) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('POST', 'servicing-v2/' + servicingId + '/files', formData).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'UPLOAD_SERVICING_FILES')

export const deleteServicingFile = (servicingId: number, fileId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('DELETE', 'servicing-v2/' + servicingId + '/files/' + fileId).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'DELETE_SERVICING_FILE')

export const deleteServicingFiles = (servicingId: number, fileIds: number[]) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('POST', 'servicing-v2/' + servicingId + '/files/bulk-delete', { file_ids: fileIds }).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'DELETE_SERVICING_FILES')

export const addServicingComment = (servicingId: number, text: string, type?: string) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('POST', 'servicing-v2/' + servicingId + '/comments', { text: text, type: type || 'comment' }).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'ADD_SERVICING_COMMENT')

export const fetchServicingLocations = (filters: any = {}) => wrap(async(dispatch:any) => {
    try {
        const params: string[] = [];
        if (filters.status) params.push('status=' + filters.status);
        return await axiosCaller('GET', 'servicing-v2/locations?' + params.join('&')).then(res => {
            dispatch({ "type": constants.FETCH_SERVICING_LOCATIONS, "payload": res.data.data });
            return res.data.data;
        })
    } catch(err) {}
}, 'FETCH_SERVICING_LOCATIONS')

export const fetchServiceHistory = (projectId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', 'servicing-v2/service-history/' + projectId).then(res => {
            return res.data.data;
        })
    } catch(err) {}
}, 'FETCH_SERVICE_HISTORY')

export const fetchServiceableProjects = () => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', 'servicing-v2/serviceable-projects').then(res => {
            dispatch({ "type": constants.FETCH_PROJECTS_FOR_SERVICE, "payload": res.data.data });
            return res.data.data;
        })
    } catch(err) {}
}, 'FETCH_SERVICEABLE_PROJECTS')

export const fetchProductTickets = (projectId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', 'servicing-v2/product-tickets/' + projectId).then(res => {
            return res.data.data;
        })
    } catch(err) {}
}, 'FETCH_PRODUCT_TICKETS')

export const fetchProductHistory = (productId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', 'servicing-v2/product-history/' + productId).then(res => {
            return res.data.data;
        })
    } catch(err) {}
}, 'FETCH_PRODUCT_HISTORY')

export const editServicing = (servicingId: number, payload: any) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('PATCH', 'servicing-v2/' + servicingId, payload).then(res => {
            if (res.data.error) return res.data;
            dispatch({ "type": constants.FETCH_SERVICING_NEW, "payload": res.data.data });
            return res.data;
        })
    } catch(err) { return err?.response?.data; }
}, 'EDIT_SERVICING')

export const voidServicing = (servicingId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('DELETE', 'servicing-v2/' + servicingId).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'VOID_SERVICING')

// =====================
// LEGACY ACTIONS
// =====================

export const getServiceRecords = (statusId?, page = 1, perPage = 20, search = '') => wrap(async(dispatch:any) => {
    try {
        let queryParams: string[] = [];
        if (statusId) queryParams.push(`status=${statusId}`);
        queryParams.push(`page=${page}`);
        queryParams.push(`per_page=${perPage}`);
        if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
        const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

        return await axiosCaller('GET', `servicing/existing/servicing${queryString}`).then(res => {
            dispatch({ "type": constants.FETCH_SERVICE_RECORDS, "payload": res.data });
        })
    } catch(err) {
    }
}, 'FETCH_EQUIPMENTS')

export const getNotRegisteredServiceRecords = (page = 1, perPage = 20, search = '') => wrap(async(dispatch:any) => {
    try {
        let queryParams: string[] = [];
        queryParams.push(`page=${page}`);
        queryParams.push(`per_page=${perPage}`);
        if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
        const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

        return await axiosCaller('GET', `servicing/non/client${queryString}`).then(res => {
            dispatch({ "type": constants.FETCH_SERVICE_RECORDS, "payload": res.data });
        })
    } catch(err) {
    }
}, 'FETCH_EQUIPMENTS')

export const getProjectReadyForService = () => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `servicing?status=1`).then(res => {
            dispatch({ "type": constants.FETCH_PROJECTS_FOR_SERVICE, "payload": res.data.data });
        })
    } catch(err) {
    }
}, 'FETCH_EQUIPMENTS')

export const createService = (payload) => wrap(async(dispatch:any) => {
    try {
        dispatch(setButtonLoading(true));
        return await axiosCaller('POST', `servicing`, payload).then(res => {
            toast.success(translatedText({id:"serviceCreated",defaultMessage:"Servisimi u krijua me sukses"}));
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
    }
}, 'FETCH_EQUIPMENTS')

export const editService = (payload, serviceId) => wrap(async(dispatch:any) => {
    try {
        dispatch(setButtonLoading(true));
        return await axiosCaller('POST', `servicing/${serviceId}`, payload).then(res => {
            toast.success(translatedText({id:"serviceUpdated",defaultMessage:"Servisimi u editua me sukses"}));
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
    }
}, 'FETCH_EQUIPMENTS')

export const getService = (serviceId) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `servicing/${serviceId}`).then(res => {
            dispatch({ "type": constants.FETCH_SERVICE, "payload": res.data.data });
        })
    } catch(err) {
    }
}, 'FETCH_EQUIPMENTS')

export const deleteServiceRecord = (serviceId) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('DELETE', `servicing/${serviceId}`).then(res => {
            toast.info(translatedText({id:"serviceDeleted",defaultMessage:"Servisimi u fshi me sukses!"}))
        })
    } catch(err) {
    }
}, 'FETCH_EQUIPMENTS')

export const setSelectedProjectForService = (payload:boolean) => wrap(async(dispatch:any, state:any) => {
    dispatch({ "type": constants.SET_SELECTED_PROJECT_FOR_SERVICE, payload: payload });
}, 'LOGIN_ERROR');

export const getServiceMapData = () => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `servicing/map`).then(res => {
            console.log(res)
            dispatch({ "type": constants.GET_SERVICE_MAP_DATA, payload: res?.data?.data });
        })
    } catch(err) {
    }
}, 'FETCH_EQUIPMENTS')